import Vue from 'vue'
import router from './router'
import { Dialog,Toast,ImagePreview } from 'vant';
import request from '@/utils/request'
import jsx from 'babel-plugin-syntax-jsx';

/* app判断是否打开功能块 start */
var shareUrl = '';
var userInfo = '';
window.appCallBack = appCallBack

Vue.prototype.$appCallBack = appCallBack
Vue.prototype.$userInfo = userInfo

var isiOSApp = false;
var jhdVisible = false;

function init(){
  var u = navigator.userAgent;
  isiOSApp = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if(!isiOSApp){
  }
  let userAgent = navigator.userAgent;
  console.log(111111111)
  console.log(userAgent)
  if (userAgent.indexOf("JHDNews") > -1) {
    jhdVisible = true;
  } else {
    jhdVisible = false;
  }
}

init()



var routePath = ''
var routeQuery = ''
Vue.prototype.$getUserInfo=(_path,_query)=>{
  _query.isUseShare = true
  routePath = _path
  routeQuery = _query
  if(isiOSApp){
    window.webkit.messageHandlers.app_call.postMessage(JSON.stringify({type: 'getUserInfo',data: {}}));
  }else{
    window.app_call.getUserInfo()
  }
}
function appCallBack(str){
  // str = '{"city_name":"","district_name":"","email":"525403886@qq.com","icon":"https://jcdn.xhby.net/JHD/resource/picture/member/20230419/1681891467159397392.png","id":"8014a4fee236426aa1bce4b8a380bfa9","introduction":"近近景近景","isOpenReporterSpace":"0","leveName":"秀才","mobile":"18066092514","myCode":"iwNr5U","name":"交汇点网友180****2514","nickName":"交汇点网友","province_name":"","sax":"男","scoreNow":"609","token":"bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaWQiOm51bGwsInVjc191c2VyX2lkIjpudWxsLCJwcmltYXJ5X2dyb3VwIjpudWxsLCJyb2xlcyI6W10sImF2YXRhciI6Imh0dHBzOi8vamNkbi54aGJ5Lm5ldC9KSEQvcmVzb3VyY2UvcGljdHVyZS9tZW1iZXIvMjAyMzA0MTkvMTY4MTg5MTQ2NzE1OTM5NzM5Mi5wbmciLCJ1dWlkIjoiODAxNGE0ZmVlMjM2NDI2YWExYmNlNGI4YTM4MGJmYTkiLCJhdXRob3JpdGllcyI6WyJuZXdzcm9vbS1qYXBpIl0sImNsaWVudF9pZCI6Im5ld3Nyb29tLWphcGkiLCJzdXBlcl9hZG1pbiI6ZmFsc2UsInRlbmFudF9hZG1pbiI6ZmFsc2UsInNjb3BlIjpbIm5ld3Nyb29tLWphcGkiXSwibmFtZSI6IuS6pOaxh-eCuee9keWPiyIsImV4cCI6MTcxNTMyNTY2NiwianRpIjoiNmQzZTkxZDItZTU2NC00YmM0LWFlZjUtZjhkZTRkMzk3NjQ2IiwidXNlcm5hbWUiOiIxODA2NjA5MjUxNCJ9.UpRDogsFX2VOMtTTQ-MJ3qtUKzT8VJRLB0np1HtEJvw","userName":"交汇点网友","webTime":0}'
  // str = '{"id":"18751950352","is_vip":false,"isOpenReporterSpace":false,"uuid":"4fe2ec7afbc142c696d9d8e4ceed011e","verifyStatus":"1","wechatID":"oUo7ts740FXaGIStA6EfIT6bnOh0","sex":"1","updateUser":"4fe2ec7afbc142c696d9d8e4ceed011e","appID":"0","updateTime":"2023-11-10T07:30:20.000+0000","scoreNow":"276","loginread":false,"nickName":"js2An1x","name":"交汇点网友j0lmf","status":"1","wechatName":"不到一百二不改名丶","days":"1","mobile":"18751950352","reporterFansNum":"0","level_name":"高级书童","scoreAll":"276","city_name":"","province_name":"","myCode":"vks0lp","attention":false,"createTime":"2023-06-07T03:28:49.000+0000","unionId":"o3mr5siMR57sojE6bCVHOaXc1lZA","citycode":"320100","district_name":"","password":"","deleteFlag":"0","phone":"18751950352","sourceCode":"0","marriage":"0"}'
  let _userInfo = JSON.parse(str);
  console.log(str)
  let _this = this
  let _id = ''
  // if(isiOSApp){
  //   _id = userInfo.uuid
  // }else{
  //   _id = ufdsserInfo.id
  // }

  if(_userInfo.mobile){
    request({
      url: `/api/v1/hlj/h5/hlj/info`,
      method: 'get',
      headers:{
        isToken:true
      }
    }).then(res=>{
      if(res.status == 200){
        Vue.prototype.$userInfo = res.data
        localStorage.setItem('loginInfo',JSON.stringify(res.data))
        Vue.prototype.$store.dispatch("setUserInfo", res.data)
        if(Vue.prototype.$userInfo){
          let _routePath = routePath
          let _routeQuery = routeQuery
          routePath = '';
          routeQuery = '';
          router.push({path:_routePath,query:_routeQuery})
        }
      }
      
    })
  }
}


Vue.prototype.$opeanApp = (_href,_query,_hrefName)=>{
  _query.isUseShare = true
  let _url = window.location.origin+window.location.pathname +'#' + _href +'?'+getUrlParam(_query)
  // Toast(_url)
  routePath = _href
  routeQuery = _query
  let _operlogObj = {
    // 操作类型：1-浏览；2-点赞；3-分享；
    operType: 1,
    operModule: _hrefName,
  }
  let _loginInfo= localStorage.getItem('loginInfo')
  console.log(_loginInfo)
  if(_loginInfo){
    let _loginInfoObj = JSON.parse(_loginInfo)
    if(_loginInfoObj.hasOwnProperty('luserId')){
      _operlogObj.operLuserId = _loginInfoObj.luserId
    }
  }
  
  if(isiOSApp){
    _operlogObj.operOs = 'IOS'
  }else{
    _operlogObj.operOs = '安卓'
  }

  request({
    url: '/api/v1/hlj/hlj/labourhome/operlog/add',
    method: 'post',
    data: _operlogObj
  }).then(res=>{
    if(isiOSApp){
      let _iosQuery = getUrlParam(_query)
      let _iosUrl = window.location.origin+window.location.pathname +'#' + _href +'?'+_iosQuery
      window.location.href = `https://jnews2.xhby.net/downloadapp/downloadapp.html?id=1&type=encode&url=${btoa(_iosUrl)}`
    }else{
      let _androidUrl = window.location.origin+window.location.pathname +'#' + _href
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.jhdapp.xhbycm&android_schema='+encodeURIComponent(`jhdapp://jhdapp?type=encode&url=${btoa(_androidUrl+'?isUseShare=true&'+getUrlParam(_query))}`)
    }
  })
}
function getUrlParam(name) {
  let params = '';
  for (let key in name) {
    if (params !== '') {
      params += '&';
    }
    params += `${encodeURIComponent(key)}=${encodeURIComponent(name[key])}`;
  }
  return params
}

/* app判断是否打开功能块 end */



// WEBPACK FOOTER //
// ./src/openApp.js